// src/utils/retryLazy.js
import { lazy } from 'react';

/**
 * 增強版的 React.lazy 函數，帶有自動重試機制
 * @param {Function} importFn - 動態導入函數，例如 () => import('./SomeComponent')
 * @param {Number} retries - 失敗後重試次數，預設 3 次
 * @param {Number} interval - 重試間隔時間 (毫秒)，預設 1500ms
 * @returns {React.LazyExoticComponent} - 增強版的 lazy 組件
 */
export const retryLazy = (importFn, retries = 3, interval = 1500) => {
  return lazy(() => {
    return new Promise((resolve, reject) => {
      // 嘗試載入元件的函數
      const attempt = () => {
        importFn()
          .then(resolve)
          .catch((err) => {
            // 檢查是否是網路錯誤（程式分割失敗）
            const isChunkLoadError = 
              err?.name === 'ChunkLoadError' || 
              (err?.message && err?.message.includes('Loading chunk') && err?.message.includes('failed'));
            
            // 如果不是網路錯誤或者已無重試次數，則拒絕
            if (retries === 0 || !isChunkLoadError) {
              reject(err);
              return;
            }
            
            console.log(`載入元件失敗，${retries}秒後重試...`, err);
            
            // 等待指定時間後重試
            setTimeout(() => {
              retries--;
              attempt();
            }, interval);
          });
      };

      // 開始首次嘗試
      attempt();
    });
  });
};

export default retryLazy;